import axios from "~/plugins/axios";

export default {
  getProductLabelsByIds(productLabelIds) {
    return axios.post("/web_api/v1/product_label/by_ids", { product_label_ids: productLabelIds }).then((response) => response.data);
  },

  getProductLabelById(id) {
    return axios.get(`/web_api/v1/product_label/${id}`).then((response) => response.data);
  },

  getByProductCategory(
    productCategory,
    orderBy,
    direction,
    perPage,
  ) {
    return axios.post("/web_api/v1/product_label/by_category", {
      product_category: productCategory,
      order_by: orderBy,
      direction,
      per_page: perPage,
    }).then((response) => response.data);
  },

  getByStaticSearchHash(staticSearchId) {
    return axios.get(`/web_api/v1/product_label/by_static_search/${staticSearchId}`).then((response) => response.data);
  },
};
